<div class="modal-dialog">
  <div class="modal-body mb-6">
    <div class="flex items-center gap-2">
      <img [src]="type === 'danger' ? '/assets/exclamation-triangle.svg' : '/assets/exclamation-triangle-warning.svg'" />
      <div [innerHTML]="message"></div>
    </div>
  </div>
  <footer class="flex items-center justify-end mt-4 gap-4 pr-2">
    <p-button type="button" styleClass="btn-contrast-workflow" (click)="confirm()">{{ confirmLabel }}</p-button>
    <p-button type="button" styleClass="btn-outlined-dark btn-workflow !px-6 !py-[7px] h-[38px]" (click)="decline()">{{ cancelLabel }}</p-button>
  </footer>
</div>
